import React from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';
import ProtocolInfoButton from '@ctsu/protocol-i-button';
import { useUsername } from 'helpers';
import { getToken } from '@ctsu/loader';
import { RenderElement } from 'components/RenderHelpers';
import { CanUserViewIbutton } from 'appconstants/Permission';

function ProtocolIButton({ protocolNumber }) {
  const userName = useUsername();
  const showButton = CanUserViewIbutton();
  return !protocolNumber ? null : (
    <RenderElement access={showButton}>
      <ProtocolInfoButton
        id={protocolNumber}
        color="#13808F"
        dataId={`${ATC.CAPID}${protocolNumber}_PROTOCOL_I_BUTTON_${ATC.LINK}`}
        getToken={getToken}
        smallSize
        userName={userName}
      />
    </RenderElement>
  );
}

export default ProtocolIButton;
